const QMS_CONFIG = {
    isQms: true,
    isWithPackages: false,
    showQueueStats: true,
    showSessionPacks: false,
    showFeeInBottomBar: true,
    showFeeInSummary: true,
    scheduleCTA: { key: "joinQueue", fallback: "Join Queue" },
    summaryCTA: { key: "confirmBooking", fallback: "Confirm Booking" },
    summaryCardTitle: {
        key: "queueBookingDetails",
        fallback: "Queue Booking Details",
    },
    stepIndicator: [
        { key: "stepVerifyNumber", fallback: "Verify your Number" },
        { key: "stepInformation", fallback: "Information" },
        { key: "stepConfirm", fallback: "Confirm" },
    ],
    slotsHeading: { key: "availableShifts", fallback: "Available Shifts" },
    slotsLoading: {
        key: "loadingShifts",
        fallback: "Loading available shifts...",
    },
    slotsEmpty: {
        key: "noShiftsAvailable",
        fallback: "No shifts available for this date",
    },
    selectedItem: { key: "selectedShift", fallback: "Selected Shift" },
    slotTimeFormat: "range",
    showDuration: false,
    confirmationStep: "queue-confirmation",
    slotFetchMode: "qms",
    bookingMode: "qms",
};
const SCHEDULED_CONFIG = {
    isQms: false,
    isWithPackages: false,
    showQueueStats: false,
    showSessionPacks: true,
    showFeeInBottomBar: true,
    showFeeInSummary: true,
    scheduleCTA: { key: "bookButton", fallback: "Book Appointment" },
    summaryCTA: { key: "payAtClinic", fallback: "Pay at Clinic" },
    summaryCardTitle: {
        key: "appointmentDetails",
        fallback: "Appointment Details",
    },
    stepIndicator: [
        { key: "stepVerifyNumber", fallback: "Verify your Number" },
        { key: "stepInformation", fallback: "Information" },
        { key: "stepPayment", fallback: "Payment" },
    ],
    slotsHeading: { key: "availableSlots", fallback: "Available Slots" },
    slotsLoading: { key: "loadingSlots", fallback: "Loading available slots..." },
    slotsEmpty: {
        key: "noSlotsAvailable",
        fallback: "No slots available for this date",
    },
    selectedItem: {
        key: "selectedAppointment",
        fallback: "Selected Appointment",
    },
    slotTimeFormat: "start",
    showDuration: true,
    confirmationStep: "success",
    slotFetchMode: "scheduled",
    bookingMode: "unified",
};
export function resolveSystemTypeConfig(activeSystemType) {
    switch (activeSystemType) {
        case "QMS":
            return QMS_CONFIG;
        default:
            return SCHEDULED_CONFIG;
    }
}
